import { render } from "./RoamingTeamForm.vue?vue&type=template&id=0d1e80db"
import script from "./RoamingTeamForm.vue?vue&type=script&lang=js"
export * from "./RoamingTeamForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__